export default "__VITE_ASSET__792a7d30__"